import { Link } from "@nextui-org/react"
import { ID_CONSTANTS } from "@circuitry-ai/doc-ui";
import { useState } from "react";

interface ChatAdvisorDetailsProps {
    description: string,
}

export function ChatAdvisorDetails(props: Readonly<ChatAdvisorDetailsProps>) {

    const { description = '' } = props;
    const [showFullDescription, setShowFullDescription] = useState(false);

    const toggleDescription = () => {
        setShowFullDescription((prev) => !prev);
    };

    const truncatedDescription = description?.length > 250 ? `${description.substring(0, 250)}...` : description;
    const displayDescription = showFullDescription ? description : truncatedDescription;

    return (
        <div className="flex flex-col justify-center items-center sm:w-[90%] md:w-[60%] mx-auto">
            <p id={ID_CONSTANTS.chatAdvisorDescription} className="text-center text-sm">
                {displayDescription}{' '}
                {description?.length > 250 && (
                    <Link onClick={toggleDescription} className="text-[#8a8a8a] cursor-pointer underline font-normal">
                        {showFullDescription ? 'show less' : 'learn more'}
                    </Link>
                )}
            </p>
        </div>
    );
}

export default ChatAdvisorDetails;
